import { lazy } from 'react'

const SiteRoutes = lazy(async () => {
  const { Sites } = await import(/* webpackChunkName: "sites" */ './index')

  return {
    default: Sites
  }
})
const routes = [
  {
    path: '/admin/sites',
    exact: false,
    render(props) {
      return <SiteRoutes {...props} />
    }
  }
]

export { routes }
